import React from 'react';
import { Bell, ChevronDown } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const Header = ({ activeTab, setActiveTab }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  const tabs = [
    { id: 'dashboard', name: 'Dashboard', route: '/dashboard' },
    { id: 'sales', name: 'Vendas', route: '/sales/flow' },
    { id: 'inventory', name: 'Estoque', route: '/inventory' },
    { id: 'financial', name: 'Financeiro', route: '/financial' },
    { id: 'reports', name: 'Relatórios', route: '/reports' }
  ];
  
  const handleTabClick = (tabId, route) => {
    setActiveTab(tabId);
    navigate(route);
  };
  
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="px-6 py-4 flex items-center justify-between">
        {/* Navigation Tabs */}
        <div className="flex space-x-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`text-sm font-medium ${
                activeTab === tab.id 
                  ? 'text-blue-900 border-b-2 border-blue-900 -mb-4 pb-4' 
                  : 'text-gray-500 hover:text-gray-900'
              }`}
              onClick={() => handleTabClick(tab.id, tab.route)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        
        {/* User Menu */}
        <div className="flex items-center space-x-4">
          <button 
            className="relative p-1 rounded-full text-gray-500 hover:bg-gray-100"
            onClick={() => navigate('/notifications')}
          >
            <Bell size={20} />
            <span className="absolute top-0 right-0 block h-4 w-4 rounded-full bg-red-500 text-xs text-white flex items-center justify-center">
              3
            </span>
          </button>
          
          <div 
            className="flex items-center cursor-pointer"
            onClick={() => navigate('/profile')}
          >
            <div className="flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600">
                {user?.initials || 'CS'}
              </div>
            </div>
            <div className="ml-2">
              <div className="text-sm font-medium text-gray-700">{user?.name || 'Carlos Santos'}</div>
            </div>
            <ChevronDown size={16} className="ml-1 text-gray-500" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;